import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getSaltLakeCityStructuredData() {
  const url = "https://restorehair.com/locations/utah/salt-lake-city/";
  const description =
    "Find out about your hair transplant options in Salt Lake City with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("salt-lake-city", url, description),
    locationPageCrumbs(url, "Salt Lake City"),
  ];
}
